import * as React from 'react';
import { useTheme } from '../../../../theme';
import { Money } from '../../../../types';
import BaggageTotalPriceBlock from '../../../BaggageTotalPriceBlock';

interface Props {
	onClickEdit?: () => void;
	price?: Money;
	minPrice: Money | null;
	isLoading?: boolean;
}

const Footer: React.FC<Props> = ({ onClickEdit, price, minPrice, isLoading }) => {
	const { Footer: css } = useTheme('AdditionalBaggage');

	return (
		<div className={css.root}>
			<BaggageTotalPriceBlock total={price} min={minPrice} onClickButton={onClickEdit} />
		</div>
	);
};

export default Footer;
